// Section types matching the main app's learning editor
export const SECTION_TYPES = {
  H1: "h1",
  H2: "h2",
  H3: "h3",
  H_GENERIC: "h",
  P: "p",
  UL: "ul",
  C: "c", // callout
  MD: "md", // markdown
  TABLE: "table",
  BTN: "btn", // button
  YT: "yt", // YouTube embed
  RESOURCES: "resources",
  ALERT: "alert",
};

export const SECTION_TYPE_LABELS = {
  [SECTION_TYPES.H1]: "Heading 1",
  [SECTION_TYPES.H2]: "Heading 2",
  [SECTION_TYPES.H3]: "Heading 3",
  [SECTION_TYPES.H_GENERIC]: "Heading (Generic)",
  [SECTION_TYPES.P]: "Paragraph",
  [SECTION_TYPES.UL]: "Unordered List",
  [SECTION_TYPES.C]: "Callout",
  [SECTION_TYPES.MD]: "Markdown",
  [SECTION_TYPES.TABLE]: "Table",
  [SECTION_TYPES.BTN]: "Button",
  [SECTION_TYPES.YT]: "YouTube Embed",
  [SECTION_TYPES.RESOURCES]: "Resources",
  [SECTION_TYPES.ALERT]: "Alert",
};

export const SECTION_TYPE_DESCRIPTIONS = {
  [SECTION_TYPES.H1]: "Main heading",
  [SECTION_TYPES.H2]: "Subheading",
  [SECTION_TYPES.H3]: "Sub-subheading",
  [SECTION_TYPES.H_GENERIC]: "Generic heading",
  [SECTION_TYPES.P]: "Text paragraph",
  [SECTION_TYPES.UL]: "Bullet list",
  [SECTION_TYPES.C]: "Highlighted callout box",
  [SECTION_TYPES.MD]: "Raw markdown text",
  [SECTION_TYPES.TABLE]: "Data table",
  [SECTION_TYPES.BTN]: "Call-to-action button (label||URL)",
  [SECTION_TYPES.YT]: "YouTube video embed",
  [SECTION_TYPES.RESOURCES]: "External resources (array of title||url)",
  [SECTION_TYPES.ALERT]: "Alert box (type||message)",
};

// Default content format for each type
export const SECTION_DEFAULTS = {
  [SECTION_TYPES.H1]: "Heading",
  [SECTION_TYPES.H2]: "Subheading",
  [SECTION_TYPES.H3]: "Sub-subheading",
  [SECTION_TYPES.H_GENERIC]: "Heading",
  [SECTION_TYPES.P]: "Paragraph text here",
  [SECTION_TYPES.UL]: "Item 1\nItem 2\nItem 3",
  [SECTION_TYPES.C]: "Important note or callout",
  [SECTION_TYPES.MD]: "# Markdown\n\nSupports **bold** and *italic*",
  [SECTION_TYPES.TABLE]: "Header 1|Header 2\nData 1|Data 2",
  [SECTION_TYPES.BTN]: "Click Here||https://example.com",
  [SECTION_TYPES.YT]: "https://youtube.com/watch?v=...",
  [SECTION_TYPES.RESOURCES]: "Title 1||https://url1.com\nTitle 2||https://url2.com",
  [SECTION_TYPES.ALERT]: "warning||Alert message here",
};
